const CONSENT_KEY = 'cookie_consent'
const GTM_ID = 'GTM-TXMSJNX'

function loadGTM() {
  if (document.getElementById('gtm-script')) return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
  const script = document.createElement('script')
  script.id = 'gtm-script'
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`
  document.head.appendChild(script)
}

function showBanner() {
  const banner = document.getElementById('cookies-eu-banner')
  if (!banner) return
  banner.style.display = ''
}

function hideBanner() {
  const banner = document.getElementById('cookies-eu-banner')
  if (!banner) return
  banner.style.display = 'none'
}

document.addEventListener('DOMContentLoaded', () => {
  const consent = localStorage.getItem(CONSENT_KEY)
  if (consent === 'accepted') loadGTM()
  if (!consent) showBanner()

  document.getElementById('cookies-eu-accept')?.addEventListener('click', () => {
    localStorage.setItem(CONSENT_KEY, 'accepted')
    hideBanner()
    loadGTM()
  })

  document.getElementById('cookies-eu-reject')?.addEventListener('click', () => {
    localStorage.setItem(CONSENT_KEY, 'rejected')
    hideBanner()
  })

  document.getElementById('cookies-manage')?.addEventListener('click', (e) => {
    e.preventDefault()
    localStorage.removeItem(CONSENT_KEY)
    showBanner()
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })
  })
})
